import { IState } from '../types';
import {
  EMainViewMode,
  IOneTimeTooltips,
  IRouteOnLogin,
  ISnackbarPanel
} from './types';
import { getNativeCaptions } from '../videos/selectors';
import { getTargetLanguage } from '../models/selectors';
import { AUTO_SPEECH_DEFAULT_RATE } from '../../components/CaptionsContainer/PlaybackSettings/constants';

export const getAutoSync = (state: IState) => state.general.autoSync || false;
export const isHoverAutoPause = (state: IState) => state.general.hoverAutoPause || false;
export const getAuthUser = (state: IState) => state.general.authUser;

export const isAuthorised = (state: IState): boolean => {
  return !!state?.general?.authUser;
}

// A logged-in (non-anonymous) user — googleId is only set for the legacy direct-Google login;
// the shared auth-service login leaves it null, so `anonymous` is the only reliable signal.
export const isLoggedUser = (state: IState): boolean => {
  const user = getAuthUser(state);
  return !!user && !user.anonymous;
}

export const getAutoPause = (state: IState) => state.general.autoPause;
export const getLibraryGroupId = (state: IState) => state.general.libraryGroupId;
export const getAudioPlayerState = (state: IState) => state.general.audioPlayerState;
export const getPlayerRate = (state: IState) => state.general.playerRate;

export const isPageLocked = (_state: IState): boolean => {
  return false;
}

export const getSnackbarPanel = (state: IState): ISnackbarPanel => state.general.snackbarPanel;
export const isShowNativeLanguageTooltip = (state: IState): boolean => state.general.oneTimeTooltip.showNativeLanguageTooltip;
export const getOneTimeTooltip = (state: IState): IOneTimeTooltips => state.general.oneTimeTooltip;
export const getMainViewMode = (state: IState): EMainViewMode => state.general.mainViewMode;

export const getShowNativeCaptions = (state: IState): boolean => state.general.showNativeCaptions;
export const getShowNativeCaptionsIfAvailable = (
  state: IState,
): boolean => {
  return getShowNativeCaptions(state) && !!getNativeCaptions(state).length;
}

export const getAuthUserLangCode = (state: IState): string => {
  return getAuthUser(state)?.langCode || getTargetLanguage(state)?.code || '';
}

export const isPauseOnNote = (state: IState): boolean => state.general.pauseOnNote;
export const getRouteOnLogin = (state: IState): IRouteOnLogin | null => state.general.routeOnLogin;
export const getVideoWatchToday = (state: IState): number | null => state.general.videoWatchToday;
export const isShowTranslations = (state: IState): boolean => !!state.general.showTranslations;

export const getUseShortcuts = (state: IState): boolean => !!state.general.useShortcuts;
export const getAutoSpeechRate = (state: IState): number => state.general.autoSpeechRate || AUTO_SPEECH_DEFAULT_RATE;
export const getSpeechLangVoiceMap = (state: IState): Record<string, string> => state.general.speechLangVoiceMap || {};
